import type { Vault } from '@/types/vault'

export const getAvailableTokens = (vaults: Vault[]) => {
  return [...new Set(vaults.map((vault) => vault.asset.symbol))]
}
